<template>
<div class="bbRefundList">
    <div class="filters">
        <div class="add">
        </div>
        <div class="search">
            <el-input v-model="param.orderno" placeholder="订单号" class="condition" clearable></el-input>
            <el-input v-model="param.title" placeholder="活动名称" class="condition" clearable></el-input>
            <el-input v-model="param.customername" placeholder="用户昵称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%" ref="multipleTable"
                  @select="handleSelectionChange">
            <!--<el-table-column type="selection" width="30" v-if="['0'].indexOf(param.status)>-1"></el-table-column>-->
            <el-table-column prop="voucherid" label="订单号" class-name="title" min-width="130px"></el-table-column>
            <el-table-column prop="subject" label="用户信息" min-width="180px" class-name="center">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.userlogo" :alt="scope.row.username"
                             preview="LeaderList">
                        <span>{{scope.row.username}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="eventtypename" label="活动名称" class-name="center"></el-table-column>
            <el-table-column prop="ordermoney " label="支付金额" class-name="center">
                <template slot-scope="scope">￥{{scope.row.ordermoney}}</template>
            </el-table-column>
            <el-table-column prop="datatime" label="订单时间" class-name="center" min-width="120px"></el-table-column>
            <el-table-column prop="applytime" label="申请时间" class-name="center" min-width="120px" v-if="param.status==98"></el-table-column>
            <el-table-column prop="refundtime" label="退款时间" class-name="center" min-width="120px" v-if="param.status==99"></el-table-column>
            <el-table-column label="操作" min-width="120px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span class="separator-btn" v-if="param.status!=1">
                            <el-button @click="handleRefund(scope.row)" type="text" size="small">退款</el-button>
                        </span>
                        <span class="separator-btn" v-if="param.status!=1">
                            <el-button @click="handleRefundReject(scope.row)" type="text" size="small">驳回</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click="handleView(scope.row)" type="text" size="small">详情</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
    <refundDialog ref="refundDialog" @refresh="refresh"></refundDialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getRefundOrderList, uploadRefundOrderResult} from 'api/brandBusiness'
import {brandBusiness} from 'api/enumCode'
import RefundDialog from 'views/brandBusiness/activityMgt/refund/components/refundDialog.vue'
export default {
    name: 'refundList',
    data() {
        return {
            tableData: [],
            init: false,
            total: 0,
            statusList: brandBusiness.orderStatus,
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            timeSlot: null,
            param: {
                customername: '',
                orderno: '',
                status: '',
                title: ''
            },
            selectedId: []
        }
    },
    mounted() {
    },
    methods: {
        initParam() {
            this.param = {
                customername: '',
                orderno: '',
                status: '',
                title: ''
            }
            this.page.page = 1
            this.timeSlot = null
            this.selectedId = []
            this.init = false
        },
        handleView(row) {
            this.$router.push({name: 'BBOrderView', query: {orderno: row.voucherid, eventid: row.eventid}})
        },
        handleSelectionChange(selection, row) {
            this.selectedId = selection
        },
        handleRefund(row) {
            this.$confirm(`<span class="tc-black">确认退款</span>￥${row.ordermoney}`, '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确认退款',
                showCancelButton: false
            }).then(() => {
                let obj = {
                    refundmemo: '',
                    status: 1,
                    eventtype: 10,
                    orderno: row.voucherid
                }
                this._refund(obj)
            })
        },
        handleRefundReject(row) {
            let obj = {
                refundmemo: '',
                status: 0,
                eventtype: 10,
                orderno: row.voucherid
            }
            this.$refs.refundDialog.openDialog(obj)
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        getList(status) {
            this.param.status = status
            if (!this.init) this._getList()
        },
        refresh() {
            this.$emit('getList')
        },
        _refresh(status) {
            this.param.status = status
            this._getList()
        },
        _refund(obj) {
            this.setLoading(true)
            uploadRefundOrderResult({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('退款成功')
                    this.$emit('getList')
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList() {
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.setLoading(true)
            getRefundOrderList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    if (this.page.page > 1 && this.page.page > data.data.pageinfo.pageCount) {
                        this.page.page = data.data.pageinfo.pageCount
                        this._getList()
                    } else {
                        this.tableData = data.data.orderlist
                        this.total = data.data.pageinfo.dataCount
                        this.init = true
                        this.setLoading(false)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {
        ...mapGetters(['params',])
    },
    computed: {
        status() {
            return function (value) {
                for (let i = 0; i < brandBusiness.orderStatus.length; i++) {
                    if (value === brandBusiness.orderStatus[i].code) {
                        return brandBusiness.orderStatus[i].cls
                    }
                }
                return value
            }
        }
    },
    components: {
        RefundDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.bbRefundList {
    .filters{
        .search{
            display: flex;
            .el-input{
                margin-right: 20px;
                width: 120px;
                input{
                    width: 100%;
                }
            }
            .el-select{
                width: 100px;
                .el-input{
                    width: 100%;
                }
            }
            .el-date-editor .el-range-separator{
                line-height: 28px;
            }
            .el-range-editor.el-input__inner{
                width: 240px;
                margin-right: 20px;
            }
        }
    }
    .imageText{
        display: flex;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .el-pagination{
        margin-top: 20px;
        text-align: center;
    }
}
</style>
